export const GET_TAXES_LIST = "GET_TAXES_LIST";
export const GET_TAXES_LIST_SUCCESS = "GET_TAXES_LIST_SUCCESS";
export const GET_TAXES_LIST_ERROR = "GET_TAXES_LIST_ERROR";

export const POST_TAX = "POST_TAX";
export const POST_TAX_SUCCESS = "POST_TAX_SUCCESS";
export const POST_TAX_ERROR = "POST_TAX_ERROR";
